import * as React from 'react'
import Seo from '../../components/seo'
import Header from '../../components/header'
import Visual from '../../components/visual'
import CloseEvent from '../../components/closeEvent'
import About from '../../components/about'
import Creator from '../../components/creator'
import Archive from '../../components/archive'
import Notes from '../../components/notes'
import Footer from '../../components/footer'
import { graphql, useStaticQuery } from 'gatsby'

const IndexPage = () => {
  const ogImage = useStaticQuery(graphql`
    {
      file(name: { eq: "ogp" }) {
        publicURL
      }
    }
  `)
  return (
    <>
      <Seo
        title="POP-UP 3D"
        description="DMM.make 3Dプリントが開催するオンライン展示。アーティストやクリエイターの作品を3Dデータ化し、VR空間上でご覧いただけます。展示されいている作品は3Dプリンターで出力したものをクリエイターズマーケットで購入することができます。"
        url="https://make.dmm.com/lp/pop-up3d/"
        image={ogImage.file.publicURL}
      />
      <div>
        <Header />
        <Visual />
        <CloseEvent />
        <About />
        <Creator />
        <Archive />
        <Notes />
        <Footer />
      </div>
    </>
  )
}

export default IndexPage
